import React, { useEffect } from 'react'

const OAuth2FailureCallback = () => {
  const params = new URLSearchParams(window.location.search)
  const error = params.get('error')

  useEffect(() => {
    if (error) {
      localStorage.setItem('social_login_error', error)
    }
    window.close()
  }, [error])

  return <div>=(</div>
}

export default OAuth2FailureCallback
